import { render, staticRenderFns } from "./LinkMenuFacebook.vue?vue&type=template&id=2df31ba2&"
import script from "./LinkMenuFacebook.vue?vue&type=script&lang=js&"
export * from "./LinkMenuFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports